import { PARTS } from "@/data/parts";

const LIMIT = { E: 2, H: 3, I: 1 };
const shuffle = (a) => { for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; } return a; };

export const weakParts = (hist, n = 3) => {
  const recent = hist.slice(0, 3);
  if (!recent.length) return [];
  return PARTS.map((p) => {
    const vals = recent.map((h) => h.parts?.[p.key]).filter((v) => v != null);
    return vals.length ? { key: p.key, name: p.name, avg: vals.reduce((s, v) => s + v, 0) / vals.length } : null;
  }).filter(Boolean).sort((a, b) => a.avg - b.avg).slice(0, n);
};

export const buildDrill = (hist, bank, timed = false, perPart = 5) => {
  const weak = weakParts(hist);
  const seen = new Set(hist.flatMap((h) => (h.items || []).map((i) => i.item.id)));
  const queue = weak.flatMap((w) => {
    const fresh = bank[w.key].filter((x) => !seen.has(x.id));
    const pool = shuffle(fresh.length ? fresh : [...bank[w.key]]);
    return pool.slice(0, LIMIT[w.key] || perPart).map((item) => ({ part: w.key, item }));
  });
  return { id: `drill-${Date.now().toString(36)}`, createdAt: new Date().toISOString(), timed, weak, queue, idx: 0, scores: [], responses: [] };
};
